import React from "react";

const Contact = () => {
  return (
    <section className="section contact">
      <h2 className="section-header menu-header">Contact Us</h2>
      <article className="section-group">
        <h2>Map of our Location</h2>
        <img src="/images/map.png" alt="Map" />
      </article>
      <article className="section-group">
        <h2>Phone</h2>
        <p>08033269773</p>
      </article>
      <article className="section-group">
        <h2>Email</h2>
        <p>
          john.toriola@yahoo.com <br />
          juperloiola@yahoo.com
        </p>
      </article>
      <article className="section-group">
        <h2>Whatsapp</h2>
        <p>08033269773</p>
      </article>
      <article className="section-group">
        <h2>Telegram</h2>
        <p>08033269773</p>
      </article>
    </section>
  );
};

export default Contact;
